import * as React from 'react';
import moment from 'moment';
import { EpiComponent, IEpiComponentState, IEpiComponentProps } from '../../global/components/epi-component';

import { IEpiProps, EpiProps } from '../models/epi-props'
import { ISearchContext, FilterParameterTypeString } from '../../global/models/search-context';
import { ISearchField, SearchOperator } from '../models/search-field';
import { IAnalytics } from '../../global/functions/analytics';

import { SearchButtons } from './search-buttons'
import { SearchContext } from './search-context'
import { SearchPreview } from './search-preview'
import { AdvancedSearchForm } from './advanced-search-form';

interface IProps {
    getEpiProps: () => Promise<{ data: IEpiProps }>
    getSearchContexts: () => Promise<ISearchContext[]>
    openLink: (url: string) => void;
    analytics: IAnalytics;
}

interface IState {
    epiProps: IEpiProps,
    searchContexts: ISearchContext[],
    initialSearchField: ISearchField,

    // Temp
    result: string,
}

export class AdvancedSearchPageApp extends React.Component<IProps, IState> {

    state: IState = {
        epiProps: new EpiProps(),
        searchContexts: [] as ISearchContext[],
        initialSearchField: null,

        result: '',
    }

    componentWillMount() {

        this.props.getEpiProps().then(json => {
            this.setState({ epiProps: json.data })
        }).catch(err => {
            console.warn(err);
        })

        this.props.getSearchContexts().then(json => {
            const initialSearchField = {
                operator: SearchOperator.And,
                filter: json[0].filters[0],
                query: '',
                valid: true
            }
            this.setState({
                searchContexts: json,
                initialSearchField: initialSearchField
            })
        }).catch(err => console.warn(err));
    }

    render() {

        const { epiProps, searchContexts, result } = this.state;

        if (searchContexts.length === 0) {
            return <h3>Loading Advanced Search...</h3>
        }

        return (
            <div>
                <AdvancedSearchForm
                    epiProps={epiProps}
                    searchContexts={searchContexts}
                    initialSearchField={this.state.initialSearchField}
                    onSearch={this.onSearch}
                    analytics={this.props.analytics} />
                {result}
            </div>
        );
    }


    // Actions
    onSearch = (context: ISearchContext, query: string) => {
        const contextId = context.id;
        const encodedQuery = encodeURIComponent(query);
        this.props.analytics.onAdvancedSearchClick();
        const url = this.state.epiProps.searchPage
            + `?context=${contextId}`
            + `&k=${encodedQuery}`;

        this.props.openLink(url);
    }
}